// extracted by mini-css-extract-plugin
export default {"cls1":"Modal-cls1___94e306e7f65184f16ac","cls2":"Modal-cls2___f041fba9dd644ac2b58 Modal-cls1___94e306e7f65184f16ac"};